module.exports = __webpack_public_path__ + "public/img/logo-round.2b4375ce.png";